import React from 'react'
import { styled } from "../../../stitches.config";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';

type ActionCardProps = {
    text: string,
    title: string,
    video: string,
}

const ActionCard = ({ text, title, video }: ActionCardProps) => {

    return (
        <Card>
            <ActionVideo>
                <iframe src={video} frameBorder='0' allow='autoplay; encrypted-media' ></iframe>
            </ActionVideo>
            <ActionContent>
                <h2 className={h2()}>{title}</h2>
                <p className={p()}>{text}</p>
            </ActionContent>
        </Card>
    )
}

export default ActionCard;

const Card = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '32px',
    '@bp4': {
        flexDirection: 'row',
        gap: '64px',
        height: '352px',
    }
})


const ActionVideo = styled('div', {
    width: '100%',
    'iframe': {
        width: '100%',
        aspectRatio: '624/352',
    },
    '@bp4': {
        width: '50%',
        'iframe': {
            width: '624px',
            aspectRatio: '624/352',
        }
    }
})

const ActionContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '90%',
    padding: '5px 0px 5px 0px',
    '*': {
        margin: 0,
    },
    '@bp4': {
        gap: '24px',
        height: '352px',
        width: '624px',
    }
})